import styled from 'styled-components';

export const NavbarStyle = styled.div`
    margin-top: 30px;
    width: 98%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 23px;
`